module.exports = __webpack_public_path__ + "static/media/bca.bd544d40.png";